export const platformSupported = (readyCallback) => {
    const isSupported = () => {
        if (!readyCallback || !readyCallback.platformConfig)
            return true;
        const capabilities = window?.SmartTag?.capabilities;
        const DEFAULT = 'DEFAULT';
        if (capabilities?.isMobile?.any() === true) {
            return true;
        }
        const currentOS = (() => {
            if (capabilities?.os !== null) {
                return capabilities?.os;
            }
            else {
                return DEFAULT;
            }
        })();
        const currentBrowser = capabilities.browser;
        const currentBrowserVersion = capabilities.browserVersion;
        const osConfig = readyCallback.platformConfig[currentOS] || readyCallback.platformConfig.DEFAULT;
        if (osConfig.disable)
            return false;
        const browserConfig = osConfig[currentBrowser] || readyCallback.platformConfig.DEFAULT[currentBrowser];
        if (!browserConfig)
            return true;
        if (browserConfig.disable)
            return false;
        if (browserConfig.minVersion && browserConfig.maxVersion)
            return browserConfig.minVersion <= currentBrowserVersion && browserConfig.maxVersion >= currentBrowserVersion;
        else if (browserConfig.minVersion)
            return browserConfig.minVersion <= currentBrowserVersion;
        else if (browserConfig.maxVersion)
            return browserConfig.maxVersion >= currentBrowserVersion;
        return true;
    };
    return new Promise((resolve, reject) => {
        isSupported() ? resolve({ supported: true }) : reject({ supported: false });
    });
};
